// Core
import { ComponentType, useEffect } from 'react';
// Packages
import { Route, Redirect, RouteComponentProps, useLocation } from 'react-router-dom';
// Redux
import { useAppSelector, STORE_KEYS, useAppDispatch } from 'redux/store';
import { saveVisitedPageLabelAsync, showSectionInNavAsync } from 'redux/nav/navThunk';
import { getSectionNavLabel } from 'redux/nav/navLabels';
// Routes
import { TRoute, ROUTES } from './routes';

type TProps = {
  component: ComponentType<RouteComponentProps>;
} & TRoute;

const PrivateRoute = ({ component: Component, routes, ...routeProps }: TProps) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { isLoggedIn, userId } = useAppSelector(STORE_KEYS.AUTH);

  const isAuth = isLoggedIn && userId;
  const hasNavLabel = !!routeProps.label;
  const sectionLabel = hasNavLabel ? undefined : getSectionNavLabel(pathname);

  useEffect(() => {
    if (routeProps.label && routeProps.label !== 'helpPage') {
      dispatch(
        saveVisitedPageLabelAsync({
          label: routeProps.label,
        }),
      );
    }
  }, [routeProps.label, dispatch]);

  // Pages without a nav label (details, Preferences...) still need a header nav after a reload
  useEffect(() => {
    if (isAuth && !hasNavLabel) {
      dispatch(showSectionInNavAsync(sectionLabel));
    }
  }, [isAuth, hasNavLabel, sectionLabel, dispatch]);

  return (
    <Route
      {...routeProps}
      render={props =>
        isAuth ? <Component routes={routes} {...props} /> : <Redirect to={ROUTES.INTRO} />
      }
    />
  );
};

export default PrivateRoute;
